
import axiosInstance from './interceptor'
export const getProjects = async (ClientId: any) => {

    return await axiosInstance.get(`/project/GetAllDetailsByClientID/${ClientId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}
export const createProjects = async (params: any) => {

    return await axiosInstance.post(`/project`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const submitCoc = async (params: any) => {

    return await axiosInstance.post(`/batch`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const submittedCocs = async (id: any) => {

    return await axiosInstance.get(`/batch/GetAllByClientID/${id}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const duplicateCoc = async (clientId: any) => {

    return await axiosInstance.get(`/batch/DuplicateBatch`, clientId).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const updateCoc = async (id: any, params: any) => {

    return await axiosInstance.put(`/batch/${id}`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getSamplesTestCoc = async (id: any) => {

    return await axiosInstance.get(`/batch/${id}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getContainerCoc = async (params: any) => {

    return await axiosInstance.post(`/Containers`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const submitLinkSample = async (params: any) => {

    return await axiosInstance.post(`/sampletest/LinkTestToSample`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getSampleContainer = async (params: any) => {

    return await axiosInstance.post(`/samplecontainers`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const retrieveContainers = async () => {

    return await axiosInstance.get(`/samplecontainers`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const deleteContainer = async (id: any) => {

    return await axiosInstance.delete(`/samplecontainers/${id}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const searchTestNames = async (search: any) => {

    return await axiosInstance.get(`/test/searchByClient`, { params: search }).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const addTestCoc = async (id: any) => {

    return await axiosInstance.get(`/batchtest/${id}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const submitTestCoc = async (params: any) => {

    return await axiosInstance.post(`/batchtest`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const loadMatrix = async (matrixId: any) => {

    return await axiosInstance.get(`/observations/${matrixId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const deleteTestRecord = async (items: any) => {

    return await axiosInstance.delete(`/batchtest`, items).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const addBulkSamples = async (params: any, config: any) => {

    return await axiosInstance.post(`/sample/AddSamplesInBulk`, params, config).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const deleteBulkSamples = async (params: any) => {

    return await axiosInstance.delete(`/Sample`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const updateSamples = async (params: any, config: any) => {

    return await axiosInstance.put(`/Sample`, params, config).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getSampleStatus = async (id: any) => {

    return await axiosInstance.get(`/sample/${id}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getObservationParentId = async (id: any) => {

    return await axiosInstance.get(`/observations/GetByParentId/${id}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const updateProjectService = async (params: any) => {

    return await axiosInstance.put(`/project/UpdateProject`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}
export const projectManagerService = async (ClientId: any) => {

    return await axiosInstance.get(`/contact/GetByClientID/${ClientId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const deleteCoc = async (id: any) => {

    return await axiosInstance.delete(`/batch/${id}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const submitCocItem = async (param: any) => {

    return await axiosInstance.post(`/batch/SubmitCOC`, param).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const sampleAddress = async (param: any) => {

    return await axiosInstance.post(`/sampleaddress`, param).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const saveCocTemplate = async (param: any) => {

    return await axiosInstance.post(`/batch/SaveCoCAsTemplate`, param).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}
export const getClientList = async (id: any) => {

    return await axiosInstance.get(`/client/${id}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const standardQuoteSearch = async (param: any) => {

    return await axiosInstance.get(`/Client/GetClientByNameOrCode/${param}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const standardQuotePriceList = async (id: any) => {

    return await axiosInstance.get(`/PriceList/${id}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const saveStandardQuote = async (param: any) => {

    return await axiosInstance.post(`/quotes`, param).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const updateQuote = async (params: any) => {

    return await axiosInstance.put(`/Quotes`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const deleteQuote = async (quoteId: any) => {

    return await axiosInstance.delete(`/quotes/DeleteQuote/${quoteId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getLabLocations = async () => {

    return await axiosInstance.get(`/location`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getContacts = async (clientId: any) => {

    return await axiosInstance.get(`/Contact/GetAllContactNamesByClientID/${clientId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const generatePdfFile = async (quoteId: any) => {

    return await axiosInstance.get(`/quotes/GeneratePDF/${quoteId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const GenerateReportForClient = async (quoteId: any, clientId: any) => {

    return await axiosInstance.get(`/quotes/GenerateReportForClient/${quoteId}/${clientId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getMatchedPriceList = async (matrixTypeId: any, priceListId: any, pageNo: any, quoteId: any, testNameOrCode: any) => {

    return await axiosInstance.get(`/test/GetAllTestDataPresentInSetsOrSuites/${matrixTypeId}/${priceListId}/${pageNo}/${quoteId}/${testNameOrCode}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getAllTestFromPriceList = async (matrixTypeId: any, priceListId: any, pageNo: any, quoteId: any, testNameOrCode: any, locationId: any) => {

    return await axiosInstance.get(`/test/GetAllTestsFromPriceList/${matrixTypeId}/${priceListId}/${pageNo}/${quoteId}/?testNameOrCode=${testNameOrCode}&locationId=${locationId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getAllTestFromSet = async (matrixTypeId: any, priceListId: any, locationId: any, setTestIds: any) => {

    return await axiosInstance.get(`/test/GetAllTestsInASet/${matrixTypeId}/${priceListId}/${locationId}/${setTestIds}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const addAssociateFee = async (param: any) => {

    return await axiosInstance.post(`/quotes/AddAssociatedFee`, param).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getMatrixType = async () => {

    return await axiosInstance.get(`/MatrixType`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getAnalysisLocation = async (id: any) => {

    return await axiosInstance.get(`/location/GetLocationsBasedOnTestId/${id}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getSearchTest = async (matrixType: any, searchText: any, priceListId: any) => {

    return await axiosInstance.get(`/test/GetTestFromTestList/${matrixType}/${searchText}/${priceListId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const addQuoteTestList = async (params: any) => {

    return await axiosInstance.post(`/quotes/AddQuotesTestList`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const deleteQuoteTest = async (params: any) => {

    return await axiosInstance.delete(`/quotes/DeleteQuotesTest`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const addQuotesPriceTables = async (params: any) => {

    return await axiosInstance.post(`/QuotesPriceTables/AddQuotesResultTables`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const updatePriceTableName = async (params: any) => {

    return await axiosInstance.put(`/QuotesPriceTables/UpdateQuotesResultTableName`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getPriceTableName = async (id: any) => {

    return await axiosInstance.get(`/quotespricetables/GetQuotesResultTables/${id}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const addQuoteTestToResultTable = async (params: any) => {

    return await axiosInstance.post(`/QuotesPriceTables/AddQuotesTestToResultTables`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getSuiteList = async (id: any) => {

    return await axiosInstance.get(`/QuotesPriceTables/GetSuitesinResultTable/${id}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getResultSummary = async (id: any) => {

    return await axiosInstance.get(`/QuotesPriceTables/GetResultsSummary/${id}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const updateAssociateFeeApi = async (params: any) => {

    return await axiosInstance.put(`/Quotes/UpdateAssociatedFee`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const deleteTestResultTable = async (params: any) => {

    return await axiosInstance.delete(`/quotespricetables/DeleteTestInResultTable`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const deleteResultTable = async (id: any) => {

    return await axiosInstance.delete(`/quotespricetables/DeleteResultTable/${id}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const viewAllQuote = async (pageNo: any, clientName: any, projectName: any, quoteNumber: any, createdBy:any) => {
    let name = clientName.length > 0 ? `&clientNameOrCode=${clientName}` : '';
    let pName = projectName.length > 0 ? `&projectName=${projectName}` : '';
    let number = quoteNumber.length > 0 ? `&quoteNumber=${quoteNumber}` : '';
    let created = createdBy.length > 0 ? `&createdBy=${createdBy}` : '';
    let questionMark = (clientName.length > 0 || quoteNumber.length > 0 || pName.length > 0 || createdBy.length > 0) ? `?` : '';

    return await axiosInstance.get(`/quotes/GetAllQuotes/${pageNo}${questionMark}${name}${pName}${number}${created}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const viewAllClientQuote = async (pageNo: any, clientId: any, projectName: any, quoteNumber: any) => {
    let pName = projectName.length > 0 ? `&projectName=${projectName}` : '';
    let number = quoteNumber.length > 0 ? `&quoteNumber=${quoteNumber}` : '';
    let questionMark = (projectName.length > 0 || quoteNumber.length > 0) ? `?` : '';

    return await axiosInstance.get(`/quotes/GetAllQuotesForClient/${pageNo}/${clientId}${questionMark}${pName}${number}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const quotePermissionCheck = async (id: any) => {

    return await axiosInstance.get(`/quotes/CheckEditQuotespermission/${id}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getQuotesList = async (id: any) => {

    return await axiosInstance.get(`/quotes/GetQuote/${id}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getAssociateFeeList = async (quoteId: any) => {

    return await axiosInstance.get(`/quotes/GetAssociatedFeeByQuoteId/${quoteId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getAnalysisList = async (quoteId: any) => {

    return await axiosInstance.get(`/quotes/GetQuotesTestByQuoteId/${quoteId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}


export const getUpdateQuoteTest = async (params: any) => {
    return await axiosInstance.put(`/Quotes/UpdateQuotesTest`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getResultTableNames = async (quoteId: any) => {

    return await axiosInstance.get(`/quotespricetables/GetQuotesResultTables/${quoteId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getResultTableData = async (quoteId: any) => {

    return await axiosInstance.get(`/quotespricetables/GetQuotesTestsInResultTableByQuoteId/${quoteId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const updateResultTableRow = async (params: any) => {

    return await axiosInstance.put(`/quotespricetables/UpdateQuotesTestInResultTable`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}


export const getBatchWithResults = async (clientId: any, reportNo: any, invoiceNumber: any, startDate: any, endDate: any, site: any) => {
    let invoice = invoiceNumber > 0 ? `&invoiceNumber=${invoiceNumber}` : '';
    let report = reportNo.length > 0 ? `&BatchId=${reportNo}` : '';
    let startDateItem = startDate !== '' ? `&startDate=${startDate}` : '';
    let endDateItem = endDate !== '' ? `&endDate=${endDate}` : '';
    let siteItem = site.length > 0 ? `&site=${site}` : '';
    let questionMark = (invoiceNumber > 0 || reportNo.length > 0 || startDate !== '' || endDate !== '' || site.length > 0) ? '?' : '';
    return await axiosInstance.get(`/BatchResults/GetBatchResults/${clientId}${questionMark}${invoice}${report}${startDateItem}${endDateItem}${siteItem}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getBatchWithOutResults = async (clientId: any) => {

    return await axiosInstance.get(`/BatchResults/GetBatchResults/${clientId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getReportsApi = async (batchId: any, isArchive: any) => {

    return await axiosInstance.get(`/BatchResults/GetReports/${batchId}/${isArchive}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getClientDetailsApi = async (batchId: any, isArchive: any) => {

    return await axiosInstance.get(`/BatchResults/GetClientManager/${batchId}/${isArchive}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getContactEmailApi = async (batchId: any, isArchive: any) => {

    return await axiosInstance.get(`/BatchResults/GetContactEmails/${batchId}/${isArchive}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getEmailContent = async (eId: any, isArchive: any) => {

    return await axiosInstance.get(`/BatchResults/GetEmailContent/${eId}/${isArchive}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const newUserRegister = async (params: any) => {

    return await axiosInstance.post(`/registration/RequestUserRegistration`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const validateUserName = async (userName: any) => {

    return await axiosInstance.get(`/Registration/IsLoginNameUsed/${userName}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getRegisterUserDetails = async (status: any, clientId: any, name: any, pageNo: any) => {
    let nameField = name.length > 0 ? `name=${name}` : '';
    let questionMark = (name.length > 0) ? '?' : '';
    return await axiosInstance.get(`/clientuser/GetAllUsersByClient/${status}/${clientId}/${pageNo}${questionMark}${nameField}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const createNewInternalUser = async (params: any) => {

    return await axiosInstance.post(`/Registration/AddNewUser`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const internalGetAllRegistration = async (userId: any, status: any, clientId: any, clientManagerId: any, name: any) => {

    let questionMark = (clientId > 0 || clientManagerId > 0 || name.length > 0) ? '?' : '';

    let params: any = [];
    params.push(clientId > 0 ? `clientId=${clientId}` : '');
    params.push(clientManagerId > 0 ? `clientManagerId=${clientManagerId}` : '');
    params.push(name.length > 0 ? `name=${name}` : '');

    let filtered = params.filter(function (el) {
        return el !== '';
    });

    let connect = filtered.length > 0 ? filtered.join('&') : filtered;

    return await axiosInstance.get(`/registration/GetAllRegistrationRequests/${userId}/${status}${questionMark}${connect}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getClientManagers = async () => {

    return await axiosInstance.get(`/User/GetClientManagers`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const approveRejectRequest = async (params: any) => {

    return await axiosInstance.post(`/registration/UpdateRegistrationRequest`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const externalGetAllRegistration = async (userId: any, status: any, isActive: any, pageNo: any, clientId: any, clientManagerId: any, name: any) => {
    let params: any = [];
    params.push(clientId > 0 ? `clientId=${clientId}` : '');
    params.push(clientManagerId > 0 ? `clientManagerId=${clientManagerId}` : '');
    params.push(name.length > 0 ? `name=${name}` : '');

    let filtered = params.filter(function (el) {
        return el !== '';
    });

    let connect = filtered.length > 0 ? filtered.join('&') : filtered;
    let questionMark = (clientId > 0 || clientManagerId > 0 || name.length > 0) ? `?` : '';

    return await axiosInstance.get(`/ClientUser/GetExternalUsers/${userId}/${status}/${isActive}/${pageNo}${questionMark}${connect}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const interUserUpdateRow = async (params: any) => {

    return await axiosInstance.put(`/ClientUser`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const externalUserUpdateRow = async (params: any) => {

    return await axiosInstance.put(`/ClientUser/UpdateExternalUser`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const shareWithCustomerApi = async (params: any) => {

    return await axiosInstance.post(`/Quotes/ShareQuote`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const sharedQuotesList = async (number: any) => {

    return await axiosInstance.get(`/Quotes/GetSharedQuotes/${number}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getQuoteStatus = async () => {

    return await axiosInstance.get(`/Quotes/GetQuoteStatus`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const updateQuoteStatus = async (params: any) => {

    return await axiosInstance.put(`/Quotes/UpdateQuoteStatus`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const cloneQuoteApi = async (id: any) => {

    return await axiosInstance.get(`/Quotes/clonequote/${id}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const newVersionApi = async (id: any) => {

    return await axiosInstance.get(`/Quotes/CreateNewVersion/${id}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const allVersionApi = async (quoteId: any) => {

    return await axiosInstance.get(`/Quotes/GetAllVersionsOfQuote/${quoteId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const newClientPriceList = async () => {

    return await axiosInstance.get(`/PriceList/GetPriceListNames`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const updateQuoteByAction = async (params: any) => {

    return await axiosInstance.put(`/Quotes/UpdateQuoteByClientAction`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const courierChargesLocation = async () => {

    return await axiosInstance.get(`/location/GetLocationForCourierCharges`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getBillingGroupTest = async (testId: any, priceListid: any, matrixTypeId: any) => {

    return await axiosInstance.get(`/BillingGroupTest/GetBillingGroupForTest/${testId}/${priceListid}/${matrixTypeId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getTestOfBillingGroup = async (billingGroupId: any, testId: any) => {

    return await axiosInstance.get(`/BillingGroupTest/GetTestsofBillingGroup/${billingGroupId}/${testId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getQuotetestGroup = async (quoteId: any) => {

    return await axiosInstance.get(`/Quotes/GetQuoteTestGroups/${quoteId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const addQuotesTestInfo = async (params: any) => {

    return await axiosInstance.post(`/quotes/AddQuotesTestInfo`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const updateTestSampleNo = async (params: any) => {

    return await axiosInstance.put(`/Quotes/UpdateQuotesTestSampleNo`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const syncApi = async (tableId: any) => {

    return await axiosInstance.get(`/SyncTable/Data/${tableId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const changePassword = async (passwords: any) => {

    return await axiosInstance.post(`/Account/change-password`, passwords).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const adminRoles = async () => {

    return await axiosInstance.get(`/Admin/GetRoles`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const internalUserSearch = async (page: any, name: any, email: any) => {

    let searchName = (name && name.length > 0) ? `name=${name}` : '';
    let searchEmail = (email && email.length > 0) ? `&email=${email}` : '';
    return await axiosInstance.get(`/User/GetInternalUsersbyNameOrEmail/${page}?${searchName}${searchEmail}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const updateUserRoleApi = async (params: any) => {

    return await axiosInstance.post(`/Admin/UpdateUserRoles`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getPriceListTest = async (id: any, page: any, name: any, code: any, shortName: any) => {
    let searchName = (name && name.length > 0) ? `testName=${name}` : '';
    let searchCode = (code && code !== '') ? `&code=${code}` : '';
    let searchShortName = (shortName && shortName.length > 0) ? `&shortName=${shortName}` : '';
    let questionMark = (name.length > 0 || code !== '' || shortName.length > 0) ? `?` : '';
    return await axiosInstance.get(`/PriceList/GetPricelistTests/${id}/${page}${questionMark}${searchName}${searchCode}${searchShortName}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getAllTestsInASet = async (testIds: any) => {

    return await axiosInstance.get(`/test/GetAllTestsInASet/${testIds}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getAllPriceListsfortheTest = async (id: any, page: any, priceListName: any) => {
    let name = (priceListName && priceListName.length > 0) ? `?priceListName=${priceListName}` : '';

    return await axiosInstance.get(`/pricelist/GetAllPricelistsfortheTest/${id}/${page}${name}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getCompareSearch = async (searchText: any) => {

    return await axiosInstance.get(`/test/search/${searchText}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const internalUserMailCheck = async (emailId: any) => {

    return await axiosInstance.get(`/contact/GetClientContactsByEmail/${emailId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getNotificationApi = async () => {

    return await axiosInstance.get(`/notification/GetNotifications`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const updateNotification = async (params: any) => {

    return await axiosInstance.put(`/notification/UpdateNotification`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getAllReleaseNotesApi = async () => {

    return await axiosInstance.get(`/notification/GetAllReleaseNotes`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getAllReleaseNotesHistoryApi = async () => {

    return await axiosInstance.get(`/notification/GetAllReleaseNotesForAdmin`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getReleaseNotesIdApi = async (id: any) => {

    return await axiosInstance.get(`/notification/GetReleaseNotes/${id}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const addReleaseNotesApi = async (params: any) => {

    return await axiosInstance.post(`/notification/AddReleaseNotes`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const updateReleaseNotesApi = async (params: any) => {

    return await axiosInstance.put(`/Notification/UpdateReleaseNotes`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const clearNotificationApi = async () => {

    return await axiosInstance.put(`/notification/ClearAllNotifications`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const deleteReleaseNotesApi = async (releaseNotesID: any) => {

    return await axiosInstance.delete(`/notification/DeleteReleaseNotes/${releaseNotesID}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const stripeCheckout = async (param: any) => {

    return await axiosInstance.post(`StripeCheckOut/create-checkout-session`, param).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

// Bottle Ordering External API Calls

export const getAllContainers = async () => {

    return await axiosInstance.get(`Containers/GetContainers`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getOrderById = async (id: any, clientId: any) => {

    return await axiosInstance.get(`BottleOrder/GetOrderbyId/${id}/${clientId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

// External user order
export const createOrder = async (data: any) => {

    return await axiosInstance.post(`BottleOrder/Create`, data).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

// Internal user order
export const createInternalUserOrder = async (data: any) => {

    return await axiosInstance.post(`BottleOrder/InternalBottleOrderRequest`, data).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const getInternalUserContacts = async (clientId: any, searchName: any) => {
    let search = (searchName && searchName.length > 0) ? `?name=${searchName}` : '';

    return await axiosInstance.get(`/Contact/GetAllContactNamesByClientID/${clientId}${search}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

// Bottle Ordering Internal API Calls

export const getAllOrders = async (clientId: any, page: any, type: any, searchOrderId: any, searchClientName: any, searchOrderedBy: any, searchDespatchLocation: any, searchOrderName: any) => {
    const params = new URLSearchParams();
    if (searchOrderId) params.set('orderId', searchOrderId);
    if (searchClientName) params.set('clientName', searchClientName);
    if (searchOrderedBy) params.set('orderedby', searchOrderedBy);
    if (searchDespatchLocation) params.set('despatchLocation', searchDespatchLocation);
    if (searchOrderName) params.set('orderName', searchOrderName);
    const queryString = params.toString();

    return await axiosInstance.get(`BottleOrder/GetAllOrders/${clientId}/${page}/${type}${queryString ? `?${queryString}` : ''}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const updateOrderApi = async (data: any) => {

    return await axiosInstance.put(`BottleOrder/Update`, data).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

//Clonethe order api
export const cloneTheOrder = async (rowId: any) => {

    return await axiosInstance.post(`BottleOrder/CloneOrder`, rowId).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

//delete all items in the order
export const deleteAllOrder = async (clientId: any) => {

    return await axiosInstance.delete(`BottleOrder/ClearDraftCheckOutItems/${clientId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

// Get User Address Api - External
export const getExternalUserAddress = async (clientId: any) => {

    return await axiosInstance.get(`client/GetClientDespatchAddresses/${clientId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

//internal user despatch location api
export const getInternalUserDespatchLocations = async () => {

    return await axiosInstance.get(`bottleorder/GetDespatchLocations`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

//internal user address location api
export const getInternalUserAddressLocations = async (pageNo: any, clientId: any, pageName: any) => {

    const questionMark = clientId ? '?' : '';
    const clientQuery = clientId ? `clientId=${clientId}` : '';
    const pageSize = 100;
    const page = pageName === 'checkout' ? `&&pageSize=${pageSize}` : '';

    return await axiosInstance.get(`client/GetClientDespatchAddressesForInternalUser/${pageNo}${questionMark}${clientQuery}${page}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

// add Internal user address api

export const addInternalUserAddress = async (params: any) => {

    return await axiosInstance.post(`Client/AddClientDespatchAddress`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

//add user address
export const addAddress = async (params: any) => {

    return await axiosInstance.post(`Client/AddClientDespatchAddress`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

//update the address api
export const updateAddress = async (params: any) => {

    return await axiosInstance.put(`client/UpdateClientDespatchAddress`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

//delete the address api
export const deleteAddress = async (id: any) => {

    return await axiosInstance.delete(`/client/DeleteClientDespatchAddress/${id}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

//get state api
export const getAllStates = async () => {

    return await axiosInstance.get(`clientuseraddress/GetStates`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

//add draft checkout items
export const addDraftCheckOutItem = async (data: any) => {

    return await axiosInstance.post(`BottleOrder/AddDraftCheckOutItems`, data).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

//get draft checkout items
export const getDraftCheckOutItems = async (clientId: any) => {

    return await axiosInstance.get(`BottleOrder/GetAllDraftCheckOutItems/${clientId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

//get draft checkout items
export const updateDraftCheckOutItems = async (params: any) => {

    return await axiosInstance.put(`BottleOrder/UpdateDraftCheckOutItem`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const deleteDraftCheckOutItem = async (
    itemToDelete: any,
    clientId: any
) => {
    const nestedItem = itemToDelete.items?.length > 0 ? true : false;

    const id = itemToDelete.id;
    const url = nestedItem
        ? `BottleOrder/RemoveDraftCheckOutItem/0/${id}/${clientId}`
        : `BottleOrder/RemoveDraftCheckOutItem/${id}/0/${clientId}`;

    return await axiosInstance
        .delete(url)
        .then((res: any) => res)
        .catch((error: any) => error.response);
};

//Bottle Order Search Test Result API
export const searchTestResult = async (searchText: any) => {

    return await axiosInstance.get(`test/search/${searchText}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

//Bottle Order Search Test Result API
export const filterContainerBasedOnTest = async (id: any) => {

    return await axiosInstance.get(`containers/GetContainersBasedOnTest/${id}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

//get all draft checkout items
export const getAllDraftCheckOutListApi = async () => {

    return await axiosInstance.get(`BottleOrder/GetAllDraftCheckOutList`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

//get quality and packing items
export const getQualityAndPackingItems = async () => {

    return await axiosInstance.get(`containers/GetBottlePackages`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

//get lab locations for bottle order
export const getBottleLabLocations = async () => {

    return await axiosInstance.get(`bottleorder/GetPickUpLocations`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

//Analytical Services
export const getAnalyticsReports = async (
    id: any,
    batchId: any,
    dateSampledFrom: any,
    dateSampledTill: any,
    projectName: any,
    clientReference: any,
    eurofinsLabNo: any,
    dateReceivedFrom: any,
    dateReceivedTill: any
) => {
    let params: string[] = [];

    if (batchId && batchId.length > 0) params.push(`batchId=${batchId}`);
    if (dateSampledFrom && dateSampledFrom.length > 0) params.push(`dateSampledFrom=${dateSampledFrom}`);
    if (dateSampledTill && dateSampledTill.length > 0) params.push(`dateSampledTill=${dateSampledTill}`);
    if (projectName && projectName.length > 0) params.push(`projectName=${projectName}`);
    if (clientReference && clientReference.length > 0) params.push(`clientReference=${clientReference}`);
    if (eurofinsLabNo && eurofinsLabNo.length > 0) params.push(`eurofinsLabNo=${eurofinsLabNo}`);
    if (dateReceivedFrom && dateReceivedFrom.length > 0) params.push(`dateReceivedFrom=${dateReceivedFrom}`);
    if (dateReceivedTill && dateReceivedTill.length > 0) params.push(`dateReceivedTill=${dateReceivedTill}`);

    let queryString = params.length > 0 ? `?${params.join('&')}` : '';

    return await axiosInstance.get(`/BatchResults/GetSampleDataReport/${id}${queryString}`).then((res: any) => {
        return res;
    }).catch((error: any) => {
        return error.response;
    });
}

//Get Active Clients
export const getActiveClients = async () => {

    return await axiosInstance.get(`/client/GetClientNames`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

//Get Client Info
export const getClientInfo = async (id: any) => {

    return await axiosInstance.get(`/Client/GetClientInfo/${id}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

//Stripe Checkout Eligibility
export const stripeCheckoutIsEligible = async (batchId: any, isArchived: boolean) => {

    return await axiosInstance.get(`/StripeCheckOut/IsEligibleForStripePayment/${batchId}/${isArchived}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

// Bottle Order flow Attachment API

export const uploadOrderAttachments = async (formData: FormData) => {
    return await axiosInstance.post(`/OrderBlob/UploadFiles`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

// Download Order Attachment API
export const downloadOrderAttachment = async (fileId: any) => {
    return await axiosInstance.get(`/OrderBlob/DownloadZippedAttachments/${fileId}`, {
        responseType: 'blob'
    }).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

// V2 Quote Get api
export const getV2Quote = async (quoteId: any) => {
    return await axiosInstance.get(`/quotes/GetV2QuotesTests/${quoteId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

// V2 Quote Submit api
export const submitV2Quote = async (payload: any) => {
    return await axiosInstance.post(`/quotes/PublishV2Quote`, payload).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

// Get Roles API
export const getRolesApi = async () => {
    return await axiosInstance.get(`/clientuser/GetCustomerRoles`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

// Get quote based container API
export const getQuoteBasedContainerApi = async (quoteId: any, clientId: any) => {
    return await axiosInstance.get(`/QuotesPriceTables/GetContainersToEachTestInResultTable/${quoteId}/${clientId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}
